/**
 * ElasticacheInternalToolQuery type policy.
 *
 * Cursor-based pagination merge for `cacheToolAuditLogFeed`. Reuses the
 * shared `mergeForPagination` helper so de-duplication by `node.id`
 * matches the rest of the cache.
 *
 * Cursor lives at `input.after` (the field's input is wrapped). When
 * absent (page 1, or any filter / sort change) we replace the cache
 * with the incoming page; when present we accumulate edges.
 */
import { mergeForPagination } from "./modules/utils";

const ElasticacheInternalToolQueryTypePolicy = {
  ElasticacheInternalToolQuery: {
    fields: {
      cacheToolAuditLogFeed: {
        keyArgs: [
          "input",
          [
            "orderBy",
            "orderByDirection",
            "filters",
            [
              "actorIdentityId",
              "operation",
              "regionUid",
              "status",
              "dryRun",
              "startedAfter",
              "startedBefore",
              "parentAuditId",
              "affectedCountAtLeast",
            ],
          ],
        ],
        merge(existing, incoming, { args, readField }) {
          return mergeForPagination({
            existing,
            incoming,
            filters: args?.input,
            readField,
          });
        },
      },
    },
  },
};

export default ElasticacheInternalToolQueryTypePolicy;
